// Copyright (c) Konnecta Systems. All rights reserved.
// Licensed under the Custom License. See LICENSE file in the project root for full license information.
// This was autogenerated by zAppDev.
import { System } from 'src/app/@framework/core/clms.fw.dotnet';
import * as Domain from '../Domain';
import * as Common from '../../@framework/common';
import { CLMS  } from 'src/app/@framework/core/clms.fw.common';
import { Joove } from 'src/app/@framework/core/Joove';
import * as moment from 'moment';
import { TranslateService } from '@ngx-translate/core';
import { DataListColumnInfo, DataListColumnItemType, ListDynamicColumnValue } from '@framework/components/DataList/helpers/List.helper.classes';
import { ValueFormat } from '@framework/core/clms.fw.angular';
var numeral = require('numeral');
const VerEx = require('verbal-expressions');


export class ProjectReview  {
    _originalTypeClassName = "Loom.BO.ProjectReview";
constructor(protected translateService: TranslateService = null) {
if (translateService != null) {
ProjectReview.translate = translateService;
}
this.Meeting = [];
this.Id = null;
this.Number = null;
this.TimingMonth = null;
this.TimingDate = null;
this.Location = null;
this.ActualDate = null;
this._key = this.Id = 0; 
}

static translate: TranslateService;
_key: any;
private _Id:any;
get Id(): any {
    return this._Id;
  }
set Id(value: any) {
    this._Id = value;
    this._key = value;
  }
Number:any;
TimingMonth:any;
TimingDate:any;
Location:any;
ActualDate:any;
Project:any;
Meeting:any;
static setProject = ($this, value) => {
var oldValue = $this.Project;
$this.Project = value;
if (value != null) {
if (oldValue != null) {
Domain.Project.removeProjectReviews(oldValue, $this);
}
Domain.Project.addProjectReviews(value, $this);
}
}
static setMeeting = ($this, items) => {
                if (items == null) items = [];
                if ($this.Meeting == null) $this.Meeting = [];

                const copyItems = Common.cloneObject(items);

                while ($this.Meeting.length > 0) {
                    Domain.ProjectReview.removeMeeting($this, $this.Meeting[0]);
                }

                Domain.ProjectReview.addManyMeeting($this, copyItems);
            }
static addManyMeeting = ($this, items) => {
                if (items == null) return;
                for (let i = 0; i < items.length; i++) {
                    Domain.ProjectReview.addMeeting($this, items[i]);
                }
            }
static addMeeting = ($this, item) => {
                if ($this.Meeting == null) $this.Meeting = [];
                if (item == null || $this.Meeting.indexOf(item) > -1) return;
                $this.Meeting.push(item);
if (item.ProjectReview != $this) {
Domain.Meeting.setProjectReview(item, $this);
}
}
static addRangeMeeting = ($this, items: System.Collections.List<any>) => { 
                items.forEach(item => Domain.ProjectReview.addMeeting($this, item));
            }
static removeMeeting = ($this, item) => {
                if ($this == null || $this.Meeting == null || $this.Meeting.indexOf(item) === -1) return;
                var _index = $this.Meeting.indexOf(item);
                $this.Meeting.splice(_index, 1);
item.ProjectReview = null;
}
static clearMeeting = ($this) => { $this.Meeting = null; }

static GetTimingDate($this: any): any{return Domain.Project.GetMonthDates($this?.Project, $this?.TimingMonth)[0];
}

static IsNew($this: any): boolean {
                if ($this == null) return true;
                return $this.Id == null || $this.Id == 0;
            }


}